import { Box, Card, CardBody, Divider, Text, VStack } from "@chakra-ui/react";
import AdvancedInputsSection from "./AdvancedInputsSection";
import FilterActionsBar from "./FilterActionsBar";
import PrimaryFilters from "./Filters/PrimaryFilters";
import Header from "./Header";
import DimensionFilters from "./Filters/DimensionFilters";
import { supportsDimensionFilters } from "./Constants/reportRequirements";

const FilterCard = ({
  analysisAvailability,
  analysisProgress,
  analysisReadiness,
  availableReports,
  currentAnalysisTypes,
  currentDataTypes,
  currentGroupByOptions,
  currentPeriodOptions,
  currentPeriods,
  excel,
  filters,
  getAdvancedReportInfo,
  getIconComponent,
  getReportList,
  handleApplyFilters,
  handleCancelAnalysis,
  handleReset,
  handleResetAllFilters,
  handleRunReport,
  isRTL,
  reportLevels,
  reportsLoading,
  requiresAdditionalData,
  selectedLevel,
  selectedReport,
  setError,
  setSelectedLevel,
  setSelectedReport,
  showReport,
  t,
  toast,
  toastMessages,
  usageLimitReached,
  isLoading,
  isAnalyzing,
}) => (
  <Card shadow="lg" border="1px solid" borderColor="gray.200" borderRadius="xl">
    <CardBody py={1} px={2}>
      <VStack spacing={1.5} align="stretch">
        <Header
          availableReports={availableReports}
          getAdvancedReportInfo={getAdvancedReportInfo}
          getIconComponent={getIconComponent}
          getReportList={getReportList}
          isRTL={isRTL}
          onLevelChange={(level) => {
            setSelectedLevel(level);
            handleReset();
          }}
          onReportChange={(report) => {
            setSelectedReport(report);
            setError(null);
            // Do NOT auto-fill the comparison period. Reports that compare periods
            // must stay gated (Analyze button disabled) until the user picks the
            // required filter themselves — see analysisReadiness.
            if (
              !supportsDimensionFilters(report) &&
              (filters?.branches?.length || filters?.projects?.length || filters?.costCenters?.length)
            ) {
              handleApplyFilters({ branches: [], projects: [], costCenters: [] });
            }
          }}
          reportLevels={reportLevels}
          reportsLoading={reportsLoading}
          selectedLevel={selectedLevel}
          selectedReport={selectedReport}
          t={t}
        />
        <Divider />
        <Box>
          <Text fontSize="sm" fontWeight="semibold" color="gray.800">
            {t("reports.primaryFilters", "Primary filters")}
          </Text>
          <PrimaryFilters
            currentGroupByOptions={currentGroupByOptions}
            currentPeriodOptions={currentPeriodOptions}
            currentPeriods={currentPeriods}
            filters={filters}
            handleApplyFilters={handleApplyFilters}
            isRTL={isRTL}
            t={t}
          />
        </Box>
        {supportsDimensionFilters(selectedReport) && (
          <Box>
            <Text fontSize="sm" fontWeight="semibold" color="gray.800">
              {t("reports.dimensionFilters", isRTL ? "فلاتر الفروع والمشاريع ومراكز التكلفة" : "Branch, project & cost center filters")}
            </Text>
            <DimensionFilters
              filters={filters}
              handleApplyFilters={handleApplyFilters}
              isRTL={isRTL}
              t={t}
            />
          </Box>
        )}
        <AdvancedInputsSection
          currentAnalysisTypes={currentAnalysisTypes}
          currentDataTypes={currentDataTypes}
          excel={excel}
          filters={filters}
          handleApplyFilters={handleApplyFilters}
          isRTL={isRTL}
          requiresAdditionalData={requiresAdditionalData}
          t={t}
        />
        <Divider />
        <FilterActionsBar
          analysisAvailability={analysisAvailability}
          analysisProgress={analysisProgress}
          analysisReadiness={analysisReadiness}
          handleCancelAnalysis={handleCancelAnalysis}
          handleReset={handleReset}
          handleResetAllFilters={handleResetAllFilters}
          handleRunReport={handleRunReport}
          isAnalyzing={isAnalyzing}
          isLoading={isLoading}
          selectedReport={selectedReport}
          showReport={showReport}
          t={t}
          toast={toast}
          toastMessages={toastMessages}
          usageLimitReached={usageLimitReached}
        />
      </VStack>
    </CardBody>
  </Card>
);

export default FilterCard;
